import PropPageInlineCOAComponent from './components/PropPageInlineCOA.vue'
import PropPageSearchComponent from './components/PropPageSearch.vue'
import { createApp } from 'vue'
import './resize'

////////////////////////////////////////////////////////////////////////////////
//
// Components
//

const components = new Map()

components.set('prop_page_inline_coa', PropPageInlineCOAComponent)
components.set('prop_page_search', PropPageSearchComponent)

document.querySelectorAll('[data-v-component-key]').forEach(e => {
    const component_key = e.getAttribute('data-v-component-key')
    const component = components.get(component_key)
    if (component) createApp(component, { ...e.dataset }).mount(e)
})
